'use strict';

import {
  investOptions,
  workplaceOptions,
  startYearOptions,
  paybackYearOptions,
  paybackPercentOptions,
} from '../../../sliders/options';
import { Operator } from '../../operator/enum/operator';

/**
 * @author Maxim Seredkin
 * @return {*}
 */
export default function () {
  return {
    restrict: 'A',
    template: require('../view/project-filter.html'),
    scope: {
      updateScopeFilters: '=myUpdate',
      filter: '=myFilter',
    },
    controller: [
      '$scope',
      '$uibModal',
      '$utils',
      'OperatorService',
      'PStatusService',
      'MunicipalityService',
      'MaintenanceKindService',
      'SupportToolService',
      'IndustryService',
      'StaffService',
      'OrgService',
      'OkvedService',
      'PhaseService',
      'AreaService',
      'ProjectService',
      '$rootScope',
      function (
        $scope,
        $modal,
        $utils,
        OperatorService,
        PStatusService,
        MunicipalityService,
        MaintenanceKindService,
        SupportToolService,
        IndustryService,
        StaffService,
        OrgService,
        OkvedService,
        PhaseService,
        AreaService,
        ProjectService,
        $rootScope
      ) {
        $scope.getOperatorDisplayName = OperatorService.getDisplayName;
        $scope.isBetween = OperatorService.isBetween;
        $scope.selectAuthor = selectAuthor;
        $scope.selectManager = selectManager;
        $scope.selectOiv = selectOiv;
        $scope.selectCuratorOiv = selectCuratorOiv;
        $scope.selectCoordorg = selectCoordorg;
        $scope.selectCoordinator = selectCoordinator;
        $scope.selectCuratorMizip = selectCuratorMizip;
        $scope.selectOkved = selectOkved;
        $scope.apply = apply;
        $scope.cancel = cancel;
        $scope.reset = reset;

        $scope.selectSettings = { ...$rootScope.selectSettings };
        $scope.selectTranslation = { ...$rootScope.selectTranslation };

        $scope.dateFormat = 'dd.MM.yyyy';

        $scope.oivFilters = [`'oiv' EQ 'true'`];
        $scope.coordorgFilters = [`'coordorg' EQ 'true'`];
        $scope.mizipFilters = [`'mizip' EQ 'true'`];
        $scope.managerFilters = [
          `EXTRA:'role' EQ 'PROJECT_MANAGER'`,
          `EXTRA:'role' EQ 'ADMINISTRATOR'`,
        ];
        $scope.curatorOivFilters = [];
        $scope.coordinatorFilters = [];
        $scope.curatorMizipFilters = [`'org.mizip' EQ 'true'`];
        $scope.curatorOivDef = {};
        $scope.coordinatorDef = {};

        $scope.operators = [];
        $scope.defaultOperator = null;
        $scope.statuses = [];
        $scope.defaultStatus = null;
        $scope.municipalities = [];
        $scope.defaultMunicipality = null;
        $scope.maintenanceKinds = [];
        $scope.defaultMaintenanceKind = null;
        $scope.supportTools = [];
        $scope.defaultSupportTool = null;
        $scope.industries = [];
        $scope.defaultIndustry = null;
        $scope.areas = [];
        $scope.filter = ProjectService.getFilter();
        $scope.localFilter = angular.copy($scope.filter);
        $scope.oldFilter = angular.copy($scope.filter);
        //$scope.filters = angular.copy(buildFilters());

        $scope.investOptions = investOptions;
        $scope.workplaceOptions = workplaceOptions;
        $scope.startYearOptions = startYearOptions;
        $scope.paybackYearOptions = paybackYearOptions;
        $scope.paybackPercentOptions = paybackPercentOptions;

        $scope.investSourceTypes = [
          { id: null, name: 'Все' },
          { id: 'owns', name: 'Частные инвестиционные проекты' },
          { id: 'budget', name: 'Проекты с бюджетным финансированием' }
        ];

        $scope.projectOptionsTypes = [
          { id: 'mcph', name: 'МЧП', icon: 'building' },
          { id: 'gcph', name: 'ГЧП', icon: 'industry' },
          { id: 'concession', name: 'Концессионное соглашение', icon: 'handshake-o' }
        ];

        load();

        /**
         * Построить фильтра
         * @return {Array}
         */
        function buildFilters() {
          let filters = [];

          // фильтр по текущему статусу проекта
          if (
            $scope.localFilter.status != null &&
            $scope.localFilter.status.id != null
          ) {
            filters.push(`EXTRA:'status' EQ '${$scope.localFilter.status.id}'`);
          }

          // фильтр по текущему статусу проекта
          if (
            $scope.localFilter.area != null &&
            $scope.localFilter.area.id != null
          ) {
            filters.push(`'area.id' EQ '${$scope.localFilter.area.id}'`);
          }

          if (
            $scope.localFilter.author != null &&
            $scope.localFilter.author.id != null
          ) {
            filters.push(`'author.id' EQ '${$scope.localFilter.author.id}'`);
          }

          if (
            $scope.localFilter.manager != null &&
            $scope.localFilter.manager.id != null
          ) {
            filters.push(`'manager.id' EQ '${$scope.localFilter.manager.id}'`);
          }

          if (
            Array.isArray($scope.localFilter.placeMunicipality) &&
            $scope.localFilter.placeMunicipality.length
          ) {
            filters.push(
              `EXTRA:'placesMunicipality' EQ '${$scope.localFilter.placeMunicipality
                .map((n) => '' + n.id)
                .join(';')}'`
            );
          }

          if (
            $scope.localFilter.placeAddress != null &&
            0 !== $scope.localFilter.placeAddress.length
          ) {
            filters.push(
              `'placeAddress' CONTAINS '${$scope.localFilter.placeAddress}'`
            );
          }

          if (
            $scope.localFilter.oiv != null &&
            $scope.localFilter.oiv.id != null
          ) {
            filters.push(`'oiv.id' EQ '${$scope.localFilter.oiv.id}'`);
          }

          if (
            $scope.localFilter.curatorOiv != null &&
            $scope.localFilter.curatorOiv.id != null
          ) {
            filters.push(
              `'curatorOiv.id' EQ '${$scope.localFilter.curatorOiv.id}'`
            );
          }

          if (
            $scope.localFilter.curatorMizip != null &&
            $scope.localFilter.curatorMizip.id != null
          ) {
            filters.push(
              `EXTRA:'curatorsMizip' EQ '${$scope.localFilter.curatorMizip.id}'`
            );
          }

          if (
            $scope.localFilter.coordorg != null &&
            $scope.localFilter.coordorg.id != null
          ) {
            filters.push(
              `'coordorg.id' EQ '${$scope.localFilter.coordorg.id}'`
            );
          }

          if (
            $scope.localFilter.coordinator != null &&
            $scope.localFilter.coordinator.id != null
          ) {
            filters.push(
              `'coordinator.id' EQ '${$scope.localFilter.coordinator.id}'`
            );
          }

          if ($scope.localFilter.startSupportYear1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorStartSupportYear)) {
              filters.push(
                `'startSupportYear' GE '${$scope.localFilter.startSupportYear1}'`
              );
              if ($scope.localFilter.startSupportYear2 != null) {
                filters.push(
                  `'startSupportYear' LE '${$scope.localFilter.startSupportYear2}'`
                );
              }
            } else {
              filters.push(
                `'startSupportYear' ${$scope.localFilter.operatorStartSupportYear} '${$scope.localFilter.startSupportYear1}'`
              );
            }
          }

          if ($scope.localFilter.planStartYear1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorPlanStartYear)) {
              filters.push(
                `'planStartYear' GE '${$scope.localFilter.planStartYear1}'`
              );
              if ($scope.localFilter.planStartYear2 != null) {
                filters.push(
                  `'planStartYear' LE '${$scope.localFilter.planStartYear2}'`
                );
              }
            } else {
              filters.push(
                `'planStartYear' ${$scope.localFilter.operatorPlanStartYear} '${$scope.localFilter.planStartYear1}'`
              );
            }
          }

          if ($scope.localFilter.planEndYear1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorPlanEndYear)) {
              filters.push(
                `'planEndYear' GE '${$scope.localFilter.planEndYear1}'`
              );
              if ($scope.localFilter.planEndYear2 != null) {
                filters.push(
                  `'planEndYear' LE '${$scope.localFilter.planEndYear2}'`
                );
              }
            } else {
              filters.push(
                `'planEndYear' ${$scope.localFilter.operatorPlanEndYear} '${$scope.localFilter.planEndYear1}'`
              );
            }
          }

          if ($scope.localFilter.planEndYear != null) {
            let year;
            if ($scope.localFilter.planEndYear instanceof Date) {
              year = $scope.localFilter.planEndYear.getFullYear();
            } else if (typeof $scope.localFilter.planEndYear === 'number') {
              year = $scope.localFilter.planEndYear;
            }
            
            if (year) {
              filters.push(`'planEndYear' EQ '${year}'`);
            }
          }

          if (
            Array.isArray($scope.localFilter.industry) &&
            $scope.localFilter.industry.length
          ) {
            filters.push(
              `EXTRA:'industry' EQ '${$scope.localFilter.industry
                .map((n) => '' + n.id)
                .join(';')}'`
            );
          }

          // фильтр по okved проекта
          if (
            $scope.localFilter.okved != null &&
            $scope.localFilter.okved.id != null
          ) {
            filters.push(`EXTRA:'okveds' IN '${$scope.localFilter.okved.id}'`);
          }

          if ($scope.localFilter.planFundsTotal1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorPlanFundsTotal)) {
              filters.push(
                `'planFundsTotal' GE '${$scope.localFilter.planFundsTotal1}'`
              );
              if ($scope.localFilter.planFundsTotal2 != null) {
                filters.push(
                  `'planFundsTotal' LE '${$scope.localFilter.planFundsTotal2}'`
                );
              }
            } else {
              filters.push(
                `'planFundsTotal' ${$scope.localFilter.operatorPlanFundsTotal} '${$scope.localFilter.planFundsTotal1}'`
              );
            }
          }

          if ($scope.localFilter.profitPlanPaybackPeriod1 != null) {
            if (
              $scope.isBetween(
                $scope.localFilter.operatorProfitPlanPaybackPeriod
              )
            ) {
              filters.push(
                `'profitPlanPaybackPeriod' GE '${$scope.localFilter.profitPlanPaybackPeriod1}'`
              );
              if ($scope.localFilter.profitPlanPaybackPeriod2 != null) {
                filters.push(
                  `'profitPlanPaybackPeriod' LE '${$scope.localFilter.profitPlanPaybackPeriod2}'`
                );
              }
            } else {
              filters.push(
                `'profitPlanPaybackPeriod' ${$scope.localFilter.operatorProfitPlanPaybackPeriod} '${$scope.localFilter.profitPlanPaybackPeriod1}'`
              );
            }
          }

          if ($scope.localFilter.profitPlanBudgetPayments1 != null) {
            if (
              $scope.isBetween(
                $scope.localFilter.operatorProfitPlanBudgetPayments
              )
            ) {
              filters.push(
                `'profitPlanBudgetPayments' GE '${$scope.localFilter.profitPlanBudgetPayments1}'`
              );
              if ($scope.localFilter.profitPlanBudgetPayments2 != null) {
                filters.push(
                  `'profitPlanBudgetPayments' LE '${$scope.localFilter.profitPlanBudgetPayments2}'`
                );
              }
            } else {
              filters.push(
                `'profitPlanBudgetPayments' ${$scope.localFilter.operatorProfitPlanBudgetPayments} '${$scope.localFilter.profitPlanBudgetPayments1}'`
              );
            }
          }

          if ($scope.localFilter.profitPlanIrr1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorProfitPlanIrr)) {
              filters.push(
                `'profitPlanIrr' GE '${$scope.localFilter.profitPlanIrr1}'`
              );
              if ($scope.localFilter.profitPlanIrr2 != null) {
                filters.push(
                  `'profitPlanIrr' LE '${$scope.localFilter.profitPlanIrr2}'`
                );
              }
            } else {
              filters.push(
                `'profitPlanIrr' ${$scope.localFilter.operatorProfitPlanIrr} '${$scope.localFilter.profitPlanIrr1}'`
              );
            }
          }

          if ($scope.localFilter.profitPlanNpv1 != null) {
            if ($scope.isBetween($scope.localFilter.operatorProfitPlanNpv)) {
              filters.push(
                `'profitPlanNpv' GE '${$scope.localFilter.profitPlanNpv1}'`
              );
              if ($scope.localFilter.profitPlanNpv2 != null) {
                filters.push(
                  `'profitPlanNpv' LE '${$scope.localFilter.profitPlanNpv2}'`
                );
              }
            } else {
              filters.push(
                `'profitPlanNpv' ${$scope.localFilter.operatorProfitPlanNpv} '${$scope.localFilter.profitPlanNpv1}'`
              );
            }
          }

          if ($scope.localFilter.profitPlanWplaces1 != null) {
            if (
              $scope.isBetween($scope.localFilter.operatorProfitPlanWplaces)
            ) {
              filters.push(
                `'profitPlanWplaces' GE '${$scope.localFilter.profitPlanWplaces1}'`
              );
              if ($scope.localFilter.profitPlanWplaces2 != null) {
                filters.push(
                  `'profitPlanWplaces' LE '${$scope.localFilter.profitPlanWplaces2}'`
                );
              }
            } else {
              filters.push(
                `'profitPlanWplaces' ${$scope.localFilter.operatorProfitPlanWplaces} '${$scope.localFilter.profitPlanWplaces1}'`
              );
            }
          }

          if ($scope.localFilter.investorSearchRequired) {
            filters.push(
              `'investorSearchRequired' EQ '${$scope.localFilter.investorSearchRequired}'`
            );
          }

          if ($scope.localFilter.federalFinancing) {
            filters.push(
              `EXTRA:'federal' EQ '${$scope.localFilter.federalFinancing}'`
            );
          }

          if ($scope.localFilter.regionalFinancing) {
            filters.push(
              `EXTRA:'regional' EQ '${$scope.localFilter.regionalFinancing}'`
            );
          }

          if ($scope.localFilter.municipalFinancing) {
            filters.push(
              `EXTRA:'municipal' EQ '${$scope.localFilter.municipalFinancing}'`
            );
          }

          if ($scope.localFilter.ownFinancing) {
            filters.push(`EXTRA:'own' EQ '${$scope.localFilter.ownFinancing}'`);
          }

          if ($scope.localFilter.resident) {
            filters.push(
              `EXTRA:'isResident' EQ '${$scope.localFilter.resident}'`
            );
          }

          if ($scope.localFilter.potentialResident) {
            filters.push(
              `EXTRA:'isPotentialResident' EQ '${$scope.localFilter.potentialResident}'`
            );
          }

          if ($scope.localFilter.isGCHP) {
            filters.push(`'isGCHP' EQ '${$scope.localFilter.isGCHP}'`);
          }

          if ($scope.localFilter.enableSigned) {
            filters.push(`EXTRA:'signed' EQ '${$scope.localFilter.signed}'`);
          }

          if (
            $scope.localFilter.dateFinancing.startDate != null ||
            $scope.localFilter.dateFinancing.endDate != null
          ) {
            const getDateOrEmplyString = (date) =>
              date instanceof Date
                ? new Date(
                    date.getTime() - date.getTimezoneOffset() * 60000
                  ).toISOString()
                : '';
            filters.push(
              `EXTRA:'period' ${Operator.BETWEEN} '${[
                $scope.localFilter.dateFinancing.startDate,
                $scope.localFilter.dateFinancing.endDate,
              ]
                .filter(Boolean)
                .map(getDateOrEmplyString)
                .join(',')}'`
            );
          }
          // фильтр по виду поддержки проекта
          if (
            $scope.localFilter.maintenanceKind != null &&
            $scope.localFilter.maintenanceKind.id != null
          ) {
            filters.push(
              `EXTRA:'maintenanceKinds' IN '${$scope.localFilter.maintenanceKind.id}'`
            );
          }

          // фильтр по инструменту поддержк проекта
          if (
            $scope.localFilter.supportTool != null &&
            $scope.localFilter.supportTool.id != null
          ) {
            filters.push(
              `EXTRA:'supportTools' IN '${$scope.localFilter.supportTool.id}'`
            );
          }

          // фильтра по этапу
          if (
            Array.isArray($scope.localFilter.phase) &&
            $scope.localFilter.phase.length
          ) {
            filters.push(
              `EXTRA:'phase' EQ '${$scope.localFilter.phase
                .map((n) => '' + n.id)
                .join(';')}'`
            );
          }

          // фильтра по статусу сущности
          if ($scope.localFilter.entityStatus != null) {
            filters.push(
              `'entityStatus' EQ '${$scope.localFilter.entityStatus}'`
            );
          }

          if ($scope.localFilter.investSource && $scope.localFilter.investSource.id) {
            filters.push(`EXTRA:'investsource' EQ '${$scope.localFilter.investSource.id}'`);
          }

          if ($scope.localFilter.projectOptions) {
            if ($scope.localFilter.projectOptions.id === 'mcph') {
              filters.push(`'isMCHP' EQ 'true'`);
            } else if ($scope.localFilter.projectOptions.id === 'gcph') {
              filters.push(`'isGCHP' EQ 'true'`);
            } else if ($scope.localFilter.projectOptions.id === 'concession') {
              filters.push(`'isConcession' EQ 'true'`);
            }
          }

          return filters;
        }

        /**
         * Загрузить данные для селекторов
         */
        function load() {
          OperatorService.api.numeric(
            null,
            (data) => ($scope.operators = data._embedded)
          );

          PStatusService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['name:ASC'],
            },
            (data) =>
              ($scope.statuses = [
                {
                  id: null,
                  name: '<Все>',
                },
              ].concat(data._embedded))
          );

          MunicipalityService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['npp:ASC', 'name:ASC'],
            },
            (data) =>
              ($scope.municipalities = [
                {
                  id: 'none',
                  name: 'Не указано',
                },
              ].concat(data._embedded))
          );

          MaintenanceKindService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['name:ASC'],
            },
            (data) =>
              ($scope.maintenanceKinds = [
                {
                  id: null,
                  name: '<Все>',
                },
              ].concat(data._embedded))
          );

          SupportToolService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['name:ASC'],
            },
            (data) =>
              ($scope.supportTools = [
                {
                  id: null,
                  name: '<Все>',
                },
              ].concat(data._embedded))
          );

          IndustryService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['npp:ASC', 'name:ASC'],
            },
            (data) =>
              ($scope.industries = [
                {
                  id: 'none',
                  name: 'Не указано',
                },
              ].concat(data._embedded))
          );

          PhaseService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['npp:ASC', 'name:ASC'],
            },
            (data) =>
              ($scope.phases = [
                {
                  id: 'none',
                  name: 'Не указано',
                },
              ].concat(data._embedded))
          );

          AreaService.api.get(
            {
              filters: [`'status' EQ 'ENABLED'`],
              sorts: ['npp:ASC', 'name:ASC'],
            },
            (data) => ($scope.areas = data._embedded?.filter(area => area.name !== 'ОЭЗ'))
          );
        }

        /**
         * Получить список авторов
         */
        function selectAuthor() {
          OrgService.select($scope.localFilter.author).result.then(function (
            data
          ) {
            $scope.localFilter.author = data;
          });
        }

        /**
         * Получить список менеджеров
         */
        function selectManager() {
          StaffService.select(
            $scope.localFilter.manager,
            [
              `EXTRA:'role' EQ 'PROJECT_MANAGER'`,
              `EXTRA:'role' EQ 'ADMINISTRATOR'`,
            ],
            { org: {} }
          ).result.then(function (data) {
            $scope.localFilter.manager = data;
          });
        }

        /**
         * Получить список ОИВ'ов
         */
        function selectOiv() {
          OrgService.select($scope.localFilter.oiv, [
            `'oiv' EQ 'true'`,
          ]).result.then(function (data) {
            $scope.localFilter.oiv = data;
          });
        }

        /**
         * Получить список кураторов ОИВ'ов
         */
        function selectCuratorOiv() {
          StaffService.select(
            $scope.localFilter.curatorOiv,
            [`'org.oiv' EQ 'true'`].concat(
              $scope.localFilter.oiv != null
                ? [`'org.id' EQ '${$scope.localFilter.oiv.id}'`]
                : []
            ),
            { org: $scope.localFilter.oiv }
          ).result.then(function (data) {
            $scope.localFilter.curatorOiv = data;
          });
        }

        /**
         * Получить список организаций-координаторов
         */
        function selectCoordorg() {
          OrgService.select($scope.localFilter.coordorg, [
            `'coordorg' EQ 'true'`,
          ]).result.then(function (data) {
            $scope.localFilter.coordorg = data;
          });
        }

        /**
         * Получить список координаторов
         */
        function selectCoordinator() {
          StaffService.select(
            $scope.localFilter.coordinator,
            [`'org.coordorg' EQ 'true'`].concat(
              $scope.localFilter.coordorg != null
                ? [`'org.id' EQ '${$scope.localFilter.coordorg.id}'`]
                : []
            ),
            { org: $scope.localFilter.coordorg }
          ).result.then(function (data) {
            $scope.localFilter.coordinator = data;
          });
        }

        /**
         * Получить список кураторов МИЗИП
         */
        function selectCuratorMizip() {
          StaffService.select(
            $scope.localFilter.curatorMizip,
            [`'org.mizip' EQ 'true'`],
            { org: {} }
          ).result.then(function (data) {
            $scope.localFilter.curatorMizip = data;
          });
        }

        /**
         * Получить список ОКВЕД'ов
         */
        function selectOkved() {
          OkvedService.select($scope.localFilter.okved).result.then(function (
            data
          ) {
            $scope.localFilter.okved = data;
          });
        }

        /**
         * Применить фильтра
         */
        function apply() {
          //$scope.filters = buildFilters();
          $scope.updateScopeFilters(buildFilters());
          $scope.oldFilter = angular.copy($scope.localFilter);
          angular.copy($scope.localFilter, $scope.filter);
          ProjectService.applyFilter(true);
          ProjectService.setFilter($scope.localFilter);
          $utils.openControlSidebar();

          sessionStorage.setItem('filters', JSON.stringify($scope.localFilter));
        }

        function firstApply() {
          const filterStorage = sessionStorage.getItem('filters');

          if (filterStorage) {
            $scope.localFilter = JSON.parse(filterStorage);

            $scope.updateScopeFilters(buildFilters());
            $scope.oldFilter = angular.copy($scope.localFilter);
            angular.copy($scope.localFilter, $scope.filter);
            ProjectService.applyFilter(true);
            ProjectService.setFilter($scope.localFilter);
          }
        }

        if ($rootScope.isFromProjectPage) {
            console.log('ww')
          firstApply();
        }

        /**
         * Отменить установку фильтров
         */
        function cancel() {
          angular.copy($scope.oldFilter, $scope.localFilter);
          $utils.openControlSidebar();
        }

        /**
         * Сбросить фильтра
         */
        function reset() {
          $scope.filterForm.$setPristine();
          ProjectService.resetFilter();
          $scope.localFilter = angular.copy(ProjectService.getFilter());
        }

        // region Watcher

        $scope.$watch('localFilter.oiv', function (nw, old) {
          if (nw) {
            $scope.curatorOivFilters = [`'org.id' EQ '${nw.id}'`];
            $scope.curatorOivDef = { org: nw };
          } else {
            $scope.curatorOivFilters = [];
            $scope.curatorOivDef = {};
          }
        });

        $scope.$watch('localFilter.coordorg', function (nw, old) {
          if (nw) {
            $scope.coordinatorFilters = [`'org.id' EQ '${nw.id}'`];
            $scope.coordinatorDef = { org: nw };
          } else {
            $scope.coordinatorFilters = [];
            $scope.coordinatorDef = {};
          }
        });

        // endregion
      },
    ],
  };
}
